module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("Hello, reader. My name is George Thomas Knowlson-Baker.")]), _vm._v(" "), _c('p', [_vm._v("I am a porter at Southmead Hospital in the City of Bristol.")]), _vm._v(" "), _c('p', [_vm._v("In this book, we are looking back at the world. Reviewing how the COVID-19 virus has had an impact. What my own experiences are and what I have done to get out of life during everything.")]), _vm._v(" "), _c('p', [_vm._v("Hopefully, you can relate to the subject and find something to pass on yourself to someone else, after watching all the loss of life during this era of disease.")]), _vm._v(" "), _c('p', [_vm._v("We all have a story to tell and this one is mine.")]), _vm._v(" "), _c('p', [_vm._v("So get ready to enter into our tale of life and wonder.")]), _vm._v(" "), _c('p', [_vm._v("The COVID-19 life book is about my own experience and impact on those around me during this pandemic.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0